import './css/styles.css';
import './scripts/types/interfaces';
import ReactDOM from 'react-dom/client';
import App from './scripts/App';

ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
).render(<App />);